export default "__VITE_ASSET__LJ0YVyHZ__"